// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, " [data-v-e47a9018-host].bottom-rewards-badge .badge--floats,:host(.bottom-rewards-badge) .badge--floats {\n  right: calc(-1 * (1px + var(--magic-space--small, 8px)));\n}", ""]);
// Exports
module.exports = exports;
